import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Flame, Star, Leaf } from "lucide-react";
import { FadeUp, ChapterHeading } from "@/components/Reveal";

const Tag = ({ tag }) => {
  if (!tag) return null;
  const map = {
    "Picant": { icon: Flame, cls: "text-red-400 border-red-500/40 bg-red-600/10" },
    "Vedeta casei": { icon: Star, cls: "text-amber-400 border-amber-500/40 bg-amber-500/10" },
    "Sezonier": { icon: Leaf, cls: "text-green-400 border-green-500/40 bg-green-600/10" },
    "La noroc": { icon: Star, cls: "text-amber-400 border-amber-500/40 bg-amber-500/10" },
    "Furat cinstit": { icon: Flame, cls: "text-red-400 border-red-500/40 bg-red-600/10" },
  };
  const t = map[tag] || map["Vedeta casei"];
  const Icon = t.icon;
  return (
    <span className={`ml-2 inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wider ${t.cls}`}>
      <Icon className="h-3 w-3" /> {tag}
    </span>
  );
};

const slugify = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-");

export const MenuSection = ({ menu, note }) => (
  <section id="meniu" className="mx-auto max-w-5xl px-5 py-24 sm:px-8">
    <ChapterHeading num="02" title="Meniul" />
    <FadeUp className="mt-6">
      <h2 className="font-display text-3xl font-bold sm:text-5xl">
        Ce punem <span className="italic text-red-400">pe masă</span>
      </h2>
      <p className="mt-4 max-w-xl text-base text-stone-400 sm:text-lg">
        Prețuri în lei, porții cinstite, glumele din partea casei.
      </p>
      {note && (
        <p data-testid="menu-note" className="font-hand mt-6 max-w-2xl -rotate-1 rounded-2xl border border-amber-500/30 bg-amber-500/10 p-5 text-xl leading-snug text-amber-300">
          {note}
        </p>
      )}
    </FadeUp>

    <FadeUp delay={0.15} className="mt-12">
      <Tabs defaultValue={slugify(menu[0].category)}>
        <TabsList data-testid="menu-tabs" className="flex h-auto flex-wrap justify-start gap-2 bg-transparent p-0">
          {menu.map((cat) => (
            <TabsTrigger
              key={cat.category}
              value={slugify(cat.category)}
              data-testid={`menu-category-tab-${slugify(cat.category)}`}
              className="rounded-full border border-stone-700 bg-transparent px-5 py-2 text-sm font-semibold text-stone-300 data-[state=active]:border-red-600 data-[state=active]:bg-red-600 data-[state=active]:text-white"
            >
              {cat.category}
            </TabsTrigger>
          ))}
        </TabsList>
        {menu.map((cat) => (
          <TabsContent key={cat.category} value={slugify(cat.category)} className="mt-8">
            <ul className="divide-y divide-stone-800">
              {cat.items.map((item) => (
                <li key={item.name} data-testid="menu-item-card" className="group py-5">
                  <div className="flex items-baseline justify-between gap-4">
                    <h4 className="font-display text-lg font-semibold text-[#FAF6F0] transition-colors group-hover:text-red-400 sm:text-xl">
                      {item.name}
                      <Tag tag={item.tag} />
                    </h4>
                    <span className="font-display shrink-0 text-lg font-bold text-red-400">
                      {item.price != null ? `${String(item.price).replace(".", ",")} lei` : "prețul zilei"}
                    </span>
                  </div>
                  <p className="mt-1 max-w-xl text-sm italic text-stone-500">{item.desc}</p>
                </li>
              ))}
            </ul>
          </TabsContent>
        ))}
      </Tabs>
    </FadeUp>
  </section>
);
